import React, { useState } from 'react';
import { Menu, X, Instagram, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cream-white/95 backdrop-blur-md border-b border-warm-gray/20 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/images/header/logo_header.png" 
              alt="D-Lyrio Logo" 
              className="h-20 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium"
            >
              INICIO
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium"
            >
              NOSOTROS
            </button>
            <button
              onClick={() => scrollToSection('trabajos')}
              className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium"
            >
              TRABAJOS
            </button>
            <button
              onClick={() => scrollToSection('catalogo')}
              className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium"
            >
              CATÁLOGO
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium"
            >
              CONTACTO
            </button>
          </nav>

          {/* Contact Icons */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://instagram.com/d_lyrioestampados"
              target="_blank"
              rel="noopener noreferrer"
              className="text-charcoal hover:text-primary-pink transition-colors duration-300"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://wa.me/59898836023"
              target="_blank"
              rel="noopener noreferrer"
              className="text-charcoal hover:text-primary-pink transition-colors duration-300"
            >
              <Phone size={20} />
            </a>
            <Button
              onClick={() => scrollToSection('cotizacion')}
              className="bg-primary-pink hover:bg-deep-navy text-cream-white px-6 py-2 rounded transition-colors duration-300"
            >
              COTIZAR
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-charcoal hover:text-primary-pink transition-colors"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-6 border-t border-warm-gray/20">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium text-left"
              >
                INICIO
              </button>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium text-left"
              >
                NOSOTROS
              </button>
              <button
                onClick={() => scrollToSection('trabajos')}
                className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium text-left"
              >
                TRABAJOS
              </button>
              <button
                onClick={() => scrollToSection('catalogo')}
                className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium text-left"
              >
                CATÁLOGO
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-charcoal hover:text-primary-pink transition-colors duration-300 text-sm tracking-wide font-medium text-left"
              >
                CONTACTO
              </button>
              <div className="flex items-center space-x-4 pt-4">
                <a
                  href="https://instagram.com/d_lyrioestampados"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-charcoal hover:text-primary-pink transition-colors duration-300"
                >
                  <Instagram size={20} />
                </a>
                <a
                  href="https://wa.me/59898836023"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-charcoal hover:text-primary-pink transition-colors duration-300"
                >
                  <Phone size={20} />
                </a>
              </div>
              <Button
                onClick={() => scrollToSection('cotizacion')}
                className="bg-primary-pink hover:bg-deep-navy text-cream-white px-6 py-2 rounded transition-colors duration-300 w-full"
              >
                COTIZAR
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
